<template>
  <el-autocomplete
    class="inline"
    v-model="val"
    value-key="name"
    :placeholder="place_holder"
    :size="size"
    :fetch-suggestions="searchQuery"
    :trigger-on-focus="false"
    clearable
    @input="handleInput"
    @select="handleSelect"
    @clear="handleClear"
  />
</template>
<script>
import { mapGetters } from "vuex";
import { auto_complete } from "@/common/mixins/auto_complete";

export default {
  name: "AUserSelector",
  mixins: [auto_complete],
  computed: {
    ...mapGetters(["table_user"]),
    items: function() {
      return this.table_user;
    }
  },
  created() {
    this.placeHolder = '사용자';
  },
  methods: {
    handleBlur() {
      if (this.results.length !== 1) {
        return;
      }
      this.$emit("select", this.results[0]);
    }
  }
};
</script>
